import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-empty-data',
    templateUrl: './empty-data.component.html',
    styleUrl: './empty-data.component.scss',
    standalone: false
})
export class EmptyDataComponent {

    @Input() illustrationSize: number = 200
    @Input() message: string = 'Nenhum resultado encontrado...'
    @Input() illustration: string = 'assets/img/illustrations/empty.svg'

    constructor() {
    }
}
